export default __webpack_public_path__ + "static/media/csv.505e51ec.png";